import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext, type UpmPlant} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {OPTIMIZER_CONSTRAINTS_QUERY_KEY, getOptimizerConstraintsPath} from '../consts'
import {OptimizerConstraints, OptimizerConstraintsDTO} from '../types'

const selectConstraints = (constraintsDTO: OptimizerConstraintsDTO): OptimizerConstraints => ({
  assets: constraintsDTO.assets,
  operationModes: constraintsDTO.operation_modes,
  combinedMarkdown: constraintsDTO.combined_markdown
})

interface OptimizerConstraintsParams {
  throwOnError?: boolean
}

export const useOptimizerConstraints = ({throwOnError = true}: OptimizerConstraintsParams = {}) => {
  const {plantId: plantCode}: UpmPlant = useUpmPlantContext()

  return useQuery<OptimizerConstraintsDTO, AxiosError, OptimizerConstraints>({
    queryKey: [OPTIMIZER_CONSTRAINTS_QUERY_KEY, {plantCode}],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<OptimizerConstraintsDTO>(
        getOptimizerConstraintsPath(plantCode),
        {signal}
      )
      return response.data
    },
    throwOnError,
    select: selectConstraints
  })
}
